import { Box, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const TypicalSection = ({
  heading,
  body,
  btnText,
  btnAction,
  sectionImg,
}: {
  heading: string;
  body: string;
  btnText: string;
  btnAction: () => void;
  sectionImg: string;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        width: "95%",
        maxWidth: "1240px",
        margin: "0 auto",
        padding: {
          xs: "55px 0",
          lg: "165px 0 185px",
        },
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        rowGap: "24px",
        flexDirection: {
          xs: "column",
          lg: "row",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: {
            xs: "24px",
            lg: "33px",
          },
          maxWidth: "540px",
        }}
      >
        <Typography
          component="h2"
          sx={{
            color: "#FFF",
            fontFamily: "HeadingNowVarTrial",
            fontStyle: "normal",
            fontWeight: 750,
            lineHeight: "130%",
            textTransform: "uppercase",
            fontSize: {
              xs: "30px",
              lg: "40px",
            },
          }}
        >
          {heading}
        </Typography>
        <Typography
          component="p"
          sx={{
            color: "#FFF",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "24px",
            minHeight: {
              xs: "unset",
              lg: "134px",
            },
          }}
        >
          {body}
        </Typography>
        <Button
          variant="primary-lg"
          onClick={btnAction}
          sx={{
            width: {
              xs: "100%",
              lg: "fit-content",
            },
            background: "var(--Green---100, #008B07)",
            color: "var(--Base-White, #FFF)",
            fontFamily: "HeadingNowVarTrial",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "24px",
          }}
        >
          {btnText}
        </Button>
      </Box>
      <motion.img
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true, amount: 0.3 }}
        src={sectionImg}
        style={{
          maxWidth: "100%",
          width: "700px",
          height: "auto",
        }}
      />
    </Box>
  );
};

export default TypicalSection;
